import type { ReactNode } from 'react';
import { Space } from 'antd';
import { ShowIconLink } from '@/components/common/ShowIconLink';
import { PublicationDrawerIcon } from './drawer/PublicationDrawerIcon';

interface PublicationIconLinkProps {
  publicationId: number;
  children?: ReactNode;
}

/** Publication reference: text, a quick-view drawer icon and a
 * `LinkOutlined` link to the show page. */
export const PublicationIconLink = ({
  publicationId,
  children,
}: PublicationIconLinkProps) => (
  <ShowIconLink resource="user_catalog.publications" id={publicationId}>
    <Space size={4}>
      {children ?? publicationId}
      <PublicationDrawerIcon publicationId={publicationId} />
    </Space>
  </ShowIconLink>
);
